<template>
  <div id="machine">
  <!-- 面包线导航 -->
    <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/welcome' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>机器人列表</el-breadcrumb-item>
        <el-breadcrumb-item>临时任务下发记录表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card >
        <!-- 第一行筛选框 -->
        <el-row :gutter="20">
               
                <el-col :span="5" >
                    <el-input placeholder="临时任务名称" v-model="temporaryInfo.name" class="m-l-30 ell-input"> </el-input>
                </el-col>
        </el-row>
        <!-- 第二行筛选框 -->
        <el-row :gutter="20" >
                  <!-- 创建时间 -->
            <el-col align="middle" >
                <el-button type="primary" @click="searchTemporarys()">查询</el-button>
                <el-button type="primary" @click="addTemporarys()">添加临时任务</el-button>
                <el-button type="primary"    @click="endTemporary()">结束当前任务</el-button>
                <el-button type="info" @click="clearParams()">重置</el-button>
                <el-button type="primary" @click="returnMissionRobot()">返回</el-button>
            </el-col>   
        </el-row>
        <!-- 用户列表区域 -->
        <el-table :data="temporaryList" border  stripe  :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}">
            <el-table-column label="序号" type="index" width="50"></el-table-column>
            <el-table-column label="机器人编号" prop="robotNo" width="250"></el-table-column>
            <el-table-column label="地图编号" prop="mapNo" width="250"></el-table-column>
            <el-table-column label="任务名称" prop="name" width="200"></el-table-column>
            <el-table-column label="执行任务点" prop="pointNos" width="200"></el-table-column>
            <el-table-column label="创建时间" prop="createTime" width="200"></el-table-column>
            <el-table-column label="操作" prop="" width="300">
                <template slot-scope="scope">
                    <el-tooltip effect="dark" content="编辑任务" placement="top" :enterable="false"  >  
                        <el-button type="primary"   size="mini" @click="editTemporaryInfo(scope.row.id)">编辑任务</el-button>
                    </el-tooltip>
                    <el-tooltip effect="dark" content="下发任务" placement="top" :enterable="false"  >  
                        <el-button type="primary"   size="mini" @click="executeTask(scope.row.id)">下发任务</el-button>
                    </el-tooltip>
                   
                    <el-tooltip effect="dark" content="删除任务" placement="top" :enterable="false"  >  
                        <el-button type="danger"   size="mini" @click="deletTemporary(scope.row.id)">删除任务</el-button>
                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>
         <!-- 分页区间 -->
        <el-pagination   @current-change="handleCurrentChange"  :current-page.sync="temporaryInfo.num"  
                :page-size="10"  layout="total, prev, pager, next"  :total="total">
        </el-pagination>
        <el-dialog title="添加临时任务"  :visible.sync="addTemporaryVisible"  width="70%" @close="addTemporaryClose" >
            <template slot="title"> 
                <div style="font-size:25px;color:blue;">添加临时任务</div>    
            </template>
                <el-row :gutter='20'>
                    <el-col :span="12">
                        <canvas id="mycanvas"  alt="" style="margin-top: 20px;height: auto;width: 100%;" />
                    </el-col>
                    <el-col :span="12">
                        <el-form :inline="true" :model="addTemporary"  ref="addTemporary"   id="selectForm">
                            <el-row >
                                <el-form-item label="任务名称:"  label-width="100px" >
                                    <el-input v-model="addTemporary.name" placeholder="任务名称" class="m-l-10 el-input" ></el-input>
                                </el-form-item>
                                <el-form-item label="请选择点位:" label-width="160px" >
                                    <el-select v-model="addTemporary.temporaryDetail.pointNo" placeholder="请选择点位" style="margin-right: 50px" class="m-l-10 el-input" @change="changeSelectId">
                                        <el-option v-for="item in pointinfoList" :key="item.pointNo" :label="item.pointNo" :value="item.pointNo" :disabled="item.disabled"  />
                                    </el-select>
                                </el-form-item>
                            </el-row>
                            <div style="border-style:solid;border-width:1px;border-color:black;min-height:200px;margin-top: 20px">
                                <span style="font-size:20px;color:blue;">点位信息编辑</span>
                            <el-row>
                                <el-form-item label="工作类型:" label-width="120px" style="margin-top: 20px;"  >
                                    <el-select v-model="addTemporary.temporaryDetail.type" placeholder="请选择"  class="m-l-10 el-input" >
                                        <el-option label="消杀" value="1"></el-option>
                                        <el-option label="行走" value="0"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item  label="工作时长:" label-width="120px" style="margin-top: 20px"  >
                                    <el-input v-model="addTemporary.temporaryDetail.time" placeholder="工作时长(s)" class="m-l-10 el-input"  oninput="value=value.replace(/^\.+|[^\d.]/g,'');if(value.length>4)value=value.slice(0,4)"></el-input>
                                </el-form-item>  
                            </el-row>
                            <el-row>
                                <el-col :span="6" :push="1" v-if="institutionType==2">                           
                                    <span style="font-size:18px;">楼栋号:</span>{{pointInfo.buildingNo}}
                                </el-col>
                                <el-col :span="5" v-if="institutionType==2" >
                                    <span style="font-size:18px;">楼层号:</span>{{pointInfo.floorNo}}
                                </el-col>
                                <el-col :span="5" v-if="institutionType==2"> 
                                    <span style="font-size:18px;">房间号:</span>{{pointInfo.roomNo}}
                                </el-col>
                                <el-col :span="8" v-if="institutionType==2"> 
                                    <span style="font-size:18px;">备注信息:</span><span style="font-size:18px;">{{pointInfo.roomInfo}}</span>
                                </el-col> 
                                <el-col :span="8" v-if="institutionType==1" :push="1" > 
                                    <span style="font-size:18px;">备注信息:</span><span style="font-size:18px;">{{pointInfo.roomInfo}}</span>
                                </el-col>  
                            </el-row>
                            <el-row>
                                <el-col :span="24" :push="15"> 
                                    <el-button type="primary"   @click="addTemporaryDetail()" > 添加点位任务</el-button>
                                    <el-button type="primary"   @click="addCleanJobDetail()">重置</el-button>
                                </el-col>    
                            </el-row>
                            </div>
                            <el-row >
                                <el-table :data="temporaryDeatilList" border  stripe  :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}" height="250">
                                <el-table-column label="序号" type="index" width="50"></el-table-column>
                                <el-table-column label="点位编号" prop="pointNo" width="80"></el-table-column>
                                <el-table-column label="点位昵称" prop="pointName" width="200"></el-table-column>
                                <el-table-column label="工作类型" prop="type" width="80">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.type==0" >
                                                    行走
                                        </span>
                                        <span v-if="scope.row.type==1" style="color:blue">
                                                    消杀
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="工作时长" prop="time" width="125">
                                     <template slot-scope="scope" >
                                        <el-input v-model="scope.row.time" style="width:100px" class="ellll-input" @input.native="onInput0_300" ></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" prop="" width="80">
                                    <template slot-scope="scope">
                                        <el-tooltip effect="dark" content="删除任务" placement="top" :enterable="false"  >  
                                            <el-button type="danger"  class="el-icon-minus"  size="mini" @click="deleteTemporaryDeatil(scope.row)"></el-button>
                                        </el-tooltip>
                                    </template>
                                </el-table-column>
                            </el-table>
                            </el-row>

                        </el-form>
                    </el-col>
                </el-row>
                <span slot="footer" class="dialog-footer">
                <el-button @click="addTemporaryVisible = false">取 消</el-button>
                <el-button type="primary" @click="addTemporaryData()">确 定</el-button>
            </span>
        </el-dialog>
        <!--编辑-->
        <el-dialog title="修改临时任务"  :visible.sync="editTemporaryVisible"  width="70%" @close="editTemporaryClose" >
            <template slot="title"> 
                <div style="font-size:25px;color:blue;">修改临时任务</div>    
            </template>
                <el-row :gutter='20'>
                    <el-col :span="12">
                        <canvas id="editmycanvas"  alt="" style="margin-top: 20px;height: auto;width: 100%;" />
                    </el-col>
                    <el-col :span="12">
                        <el-form :inline="true" :model="editTemporary"  ref="addTemporary"   id="selectForm">
                            <el-row >
                                <el-form-item label="任务名称:"  label-width="100px" >
                                    <el-input v-model="editTemporary.name" placeholder="任务名称" class="m-l-10 el-input" ></el-input>
                                </el-form-item>
                                <el-form-item label="请选择点位:" label-width="160px" >
                                    <el-select v-model="editTemporary.temporaryDetail.pointNo" placeholder="请选择点位" style="margin-right: 50px" class="m-l-10 el-input" @change="editChangeSelectId">
                                        <el-option v-for="item in pointinfoList" :key="item.pointNo" :label="item.pointNo" :value="item.pointNo" :disabled="item.disabled"  />
                                    </el-select>
                                </el-form-item>
                            </el-row>
                            <div style="border-style:solid;border-width:1px;border-color:black;min-height:200px;margin-top: 20px">
                                <span style="font-size:20px;color:blue;">点位信息编辑</span>
                            <el-row>
                                <el-form-item label="工作类型:" label-width="120px" style="margin-top: 20px;"  >
                                    <el-select v-model="editTemporary.temporaryDetail.type" placeholder="请选择"  class="m-l-10 el-input" >
                                        <el-option label="消杀" value="1"></el-option>
                                        <el-option label="行走" value="0"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item  label="工作时长:" label-width="120px" style="margin-top: 20px"  >
                                    <el-input v-model="editTemporary.temporaryDetail.time" placeholder="工作时长(s)" class="m-l-10 el-input"  oninput="value=value.replace(/^\.+|[^\d.]/g,'');if(value.length>4)value=value.slice(0,4)"></el-input>
                                </el-form-item>  
                            </el-row>
                            <el-row>
                                <el-col :span="6" :push="1" v-if="institutionType==2">                           
                                    <span style="font-size:18px;">楼栋号:</span>{{pointInfo.buildingNo}}
                                </el-col>
                                <el-col :span="5" v-if="institutionType==2">
                                    <span style="font-size:18px;">楼层号:</span>{{pointInfo.floorNo}}
                                </el-col>
                                <el-col :span="5" v-if="institutionType==2"> 
                                    <span style="font-size:18px;">房间号:</span>{{pointInfo.roomNo}}
                                </el-col>
                                <el-col :span="8" v-if="institutionType==2"> 
                                    <span style="font-size:18px;">备注信息:</span> <span style="font-size:18px;">{{pointInfo.roomInfo}}</span>
                                </el-col> 
                                <el-col :span="8" v-if="institutionType==1" :push="1" > 
                                    <span style="font-size:18px;">备注信息:</span><span style="font-size:18px;">{{pointInfo.roomInfo}}</span>
                                </el-col>   
                            </el-row>
                            <el-row>
                                <el-col :span="24" :push="15"> 
                                    <el-button type="primary"   @click="editTemporaryDetail()" > 添加点位任务</el-button>
                                    <el-button type="primary"   @click="editCleanJobDetail()">重置</el-button>
                                </el-col>    
                            </el-row>
                            </div>
                            <el-row >
                                <el-table :data="temporaryDeatilList" border  stripe  :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}" height="250">
                                <el-table-column label="序号" type="index" width="50"></el-table-column>
                                <el-table-column label="点位编号" prop="pointNo" width="80"></el-table-column>
                                <el-table-column label="点位昵称" prop="pointName" width="200"></el-table-column>
                                <el-table-column label="工作类型" prop="type" width="80">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.type==0" >
                                                    行走
                                        </span>
                                        <span v-if="scope.row.type==1" style="color:blue">
                                                    消杀
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="工作时长" prop="time" width="125">
                                     <template slot-scope="scope" >
                                        <el-input v-model="scope.row.time" style="width:100px" class="ellll-input" @input.native="onInput0_300" ></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" prop="" width="80">
                                    <template slot-scope="scope">
                                        <el-tooltip effect="dark" content="删除任务" placement="top" :enterable="false"  >  
                                            <el-button type="danger"  class="el-icon-minus"  size="mini" @click="deleteTemporaryDeatil(scope.row)"></el-button>
                                        </el-tooltip>
                                    </template>
                                </el-table-column>
                            </el-table>
                            </el-row>

                        </el-form>
                    </el-col>
                </el-row>
                <span slot="footer" class="dialog-footer">
                <el-button @click="editTemporaryVisible = false">取 消</el-button>
                <el-button type="primary" @click="updateTemporaryData()">确 定</el-button>
            </span>
        </el-dialog>
        <!--进度条-->
         <!--下发任务进度条 -->
        <el-dialog title="下发任务中"  :visible.sync="temporaryVisible" class="taskdialog" :showClose="false" @close="temporaryDialogClose">
            <el-progress type="circle" :percentage="temporaryPercentage" :status="progressStatus"></el-progress>
        </el-dialog>
        <!--结束进度条 -->
        <el-dialog title="下发结束任务中"  :visible.sync="endTaskVisible" class="taskdialog" :showClose="false" @close="endTemporaryDialogClose">
            <el-progress type="circle" :percentage="endTemporaryPercentage" :status="endProgressStatus"></el-progress>
        </el-dialog>

    </el-card >
  </div>
</template>

<script>

import { mapState } from 'vuex'
export default {
  name: 'machine',
  data(){
      return {
          temporaryInfo :{
              robotNo:'',
              mapId:'',
              mapNo:'',
              name:'',
              num:1,
          },
          addTemporary:{
              name:'',
              temporaryDetail:{
                type:'',
                pointname:'',
                time:'300',
                pointNo:'',
                pointInfoid:'',
              }
          },
          editTemporary:{
              name:'',
              temporaryDetail:{
                type:'',
                pointname:'',
                time:'300',
                pointNo:'',
                pointInfoid:'',
              }
          },
          institutionType:'',//机器人所属机构
          dataMap:'',
          total:0,
          temporaryList:[],
          addTemporaryVisible:false,
          topic1:'',
          globleX:'',
          globleY :'',
          pointInfo:{},
          temporaryDeatilList:[],
          pointinfoList:[],
          gcanvas:null,
          editTemporaryVisible:false,
          temporaryVisible:false, //进度条弹框关闭
          temporaryPercentage:0, //进度条弹初始值
          progressStatus:null,//进度条颜色初始值
          progressBar:false,
          taskTimer:null,
          endTaskVisible:false,//进度条弹框关闭
          endProgressStatus:null,//进度条颜色初始值
          endTemporaryPercentage:0,//进度条弹初始值
          endProgressBar:false,
          endTimer:''
      }
  },
   computed: mapState([
    // 映射 this.count 为 store.state.count
    'mqttClient'
   ]),
   //生命周期函数
  created(){
    this.temporaryInfo.robotNo=this.$route.query.robotNo;
    this.temporaryInfo.mapId=this.$route.query.mapId;
    this.connectMqtt();
  
  },
   beforeRouteLeave(to, form, next) {
        if(this.mqttClient!=='' && this.mqttClient!==null){
            this.unsubscribe()
        } 
        next()
  },
  methods:{
        onInput0_300(e) {
            this.$message.closeAll();
            if (e.target.value <= 1 || e.target.value > 300) {
                this.$message.warning("只能输入[1,300]区间的数");
            }
            e.target.value = (e.target.value >= 1 && e.target.value <= 300 && e.target.value.match(/^\d{1,3}(\.\d*)?$/)[0]) || null;
        },
        endTemporaryDialogClose(){
            this.endTemporaryPercentage=0;
            this.endProgressStatus=null;
            this.endProgressBar=false;
        },
        temporaryDialogClose(){
            this.temporaryPercentage=0;
            this.progressStatus=null;
            this.progressBar=false;
        },
        //结束当前任务
        endTemporary(){
            let that=this
            this.$http.get('map/endTask',{params :{ robotNo : this.temporaryInfo.robotNo,mapNo :  this.temporaryInfo.mapNo }})
            .then(response => {
                if (response.data.code === 200) {
                    that.endTaskVisible=true;
                    that.endTemporaryPercentage=10
                    clearInterval(that.endTimer)
                    let timeOut=0
                    that.endTimer = setInterval(function(){
                        //正常关闭
                        if(that.endProgressBar){
                            //关闭进度条
                            that.endTaskVisible=false;
                            //关闭定时器
                            clearInterval(that.endTimer);
                        }
                        //超时关闭
                        if(timeOut==9){
                            that.endProgressStatus="exception"
                            that.$message.error("回复超时!");
                            //延迟关闭进度条
                            setTimeout(function(){
                                    //关闭进度条
                                    that.endTaskVisible=false;
                            }, 1000)
                            //关闭定时器
                            clearInterval(that.taskTimer);
                        }
                        if(that.endTemporaryPercentage < 90){
                            that.endTemporaryPercentage=that.endTemporaryPercentage+10
                        }
                        timeOut +=1    
                     },1000)
                    return
                }else{
                     return this.$message.error(response.data.message);
                }
                }).catch(failResponse => {
                
            })
        },
        //下发任务
        executeTask(obj){
            let that=this;
            this.$http.get('map/executeTemporaryTask',{params :{ id : obj}}) .then(response => {
                if (response.data.code === 200) {
                    that.temporaryVisible=true;
                    that.temporaryPercentage=10
                    clearInterval(that.taskTimer)
                    let timeOut=0
                    that.taskTimer = setInterval(function(){
                        //正常关闭
                        if(that.progressBar){
                            //关闭进度条
                            that.temporaryVisible=false;
                            //关闭定时器
                            clearInterval(that.taskTimer);
                        }
                        //超时关闭
                        if(timeOut==9){
                            that.progressStatus="exception"
                            that.$message.error("回复超时!");
                            //延迟关闭进度条
                            setTimeout(function() {
                                    //关闭进度条
                                    that.temporaryVisible=false;
                            }, 1000)
                            //关闭定时器
                            clearInterval(that.taskTimer);
                        }
                        if(that.temporaryPercentage < 90){
                            that.temporaryPercentage=that.temporaryPercentage+10
                            console.log(that.temporaryPercentage)
                        }
                        timeOut +=1    
                    },1000);
                    return
                }else{
                     return this.$message.error(response.data.message);
                }
                }).catch(failResponse => {
            })
        },
        init(){
            var robotNo=this.$route.query.robotNo;
            if(robotNo==undefined||robotNo==''){
                this.$message.error("页面信息错误,请重新登录!");
                return
            }
            var topic1="/Unione/CommandReply/"+robotNo
            this.topic1=topic1

            try {
                this.mqttClient.subscribe(topic1, { qos: 0 }, (error) => {
                        window.sessionStorage.setItem("subscribe",0)
                        console.log('连接成功'+topic1)
                        if (!error) {
                        console.log('订阅成功')
                        } else {
                        console.log('订阅失败')
                        }
                })
            } catch (e) {
                var subscribe=window.sessionStorage.getItem('subscribe')
                if(subscribe*1===1){
                    this.$message.error("网络差,退出重新登录!");
                    return this.$router.push('/login') 

                }else{
                    window.sessionStorage.setItem("subscribe",1)
                    this.$store.dispatch('mqttServer')
                    location.reload()
                    return 
                }
                
            }
           
            let that=this
            // 接收消息处理
            this.mqttClient.on('message', (topic, message) => {
                var data =JSON.parse(message)
                //消息回复
                if(topic == that.topic1){
                        //接受临时任务回调
                        if(that.temporaryVisible &&  data.type=='4'){
                            if(data.code != "0" ){
                                    that.$message.error(data.detail);
                                    that.progressStatus="exception"
                                    that.progressBar=true
                            }else{
                                    that.temporaryPercentage=100
                                    that.progressBar=true
                            }
                        }
                        //结束任务回调
                        if(that.endTaskVisible &&  data.type=='5'){
                            console.log("-------")
                            if(data.code != "0" ){
                                    that.$message.error(data.detail);
                                    that.endProgressBar="exception"
                                    that.endProgressBar=true
                            }else{
                                    that.endTemporaryPercentage=100
                                    that.endProgressBar=true
                            }
                        }
                }
            })
        },
        updateTemporaryData(){
            if(this.editTemporary.name==''){
                return this.$message.error("请输入任务名称!");
            }
            if(this.temporaryDeatilList.length==0){
                return this.$message.error("请编辑任务点信息!");
            }
            var pointNos=[];
            for(var i=0;i<this.temporaryDeatilList.length;i++){
                pointNos.push(this.temporaryDeatilList[i].pointName)
                if(this.temporaryDeatilList[i].time==""){
                    return this.$message.error("请补充点位编号为"+this.temporaryDeatilList[i].pointNo+"的任务消杀时长!");
                }
            }
            let temporary={robotNo:this.temporaryInfo.robotNo,mapNo: this.temporaryInfo.mapNo,name:this.editTemporary.name,temporaryDetails:this.temporaryDeatilList,id:this.editTemporary.id ,pointNos:pointNos.join(",")}; 
            this.$http.post('/temporary/updateTemporary',JSON.stringify(temporary)) .then(response => {
                if (response.data.code === 200) {
                   this.$message.success("更新成功!");
                   this.searchTemporarys();
                   this.editTemporaryVisible=false;
                   return
                }else{
                     return this.$message.error(response.data.message);
                }
                }).catch(failResponse => {
            })
        },
        //关闭编辑框
        editTemporaryClose(){
            this.clearCanvas('editmycanvas');
            this.pointInfo={};
            this.editTemporary.temporaryDetail.pointNo='';
            this.editTemporary.temporaryDetail.time=300;
            this.editTemporary.temporaryDetail.type='';
            this.pointinfoList=[];
            this.dataMap='';
            this.temporaryDeatilList=[];
            this.editTemporary.name='';
            this.gcanvas=null
        },
        //编辑临时任务
        editTemporaryInfo(obj ){
            if(this.institutionType==2){
                let that=this
                this.$http.get('temporary/getTemporaryInfo',{params :{ id : obj }})
                .then(response => {
                        if (response.data.code === 200) {
                            this.editTemporaryVisible=true;
                            this.temporaryDeatilList=response.data.result.temporaryDetails
                            this.editTemporary.name=  response.data.result.name
                            this.editTemporary.id=  response.data.result.id
                            this.$http.get('map/findMapById',{params :{ mapId : this.temporaryInfo.mapId}})
                            .then(response => {
                                    if (response.data.code === 200) {
                                        that.dataMap=response.data.result
                                        that.temporaryInfo.mapNo=that.dataMap.mapNo
                                        that.$http.get('map/findPointInfos',{params :{ robotNo : that.temporaryInfo.robotNo,mapNo : that.temporaryInfo.mapNo}})
                                            .then(response => {
                                                    if (response.data.code === 200) {
                                                        that.pointinfoList=response.data.result
                                                        that.$nextTick(() => {  
                                                            that.downloadOFile(that.dataMap.orginUrl,that.dataMap,"editmycanvas");
                                                        }).catch(failResponse => {})
                                                    }
                                                    
                                            }).catch(failResponse => {
                                        })
                                        
                                    }else{
                                        return this.$message.error(response.data.message);
                                    }
                                }).catch(failResponse => {
                                
                            })
                        }else{
                            return this.$message.error(response.data.message);
                        }
                    }).catch(failResponse => {
                })
            }else{
                 let that=this
                 this.$http.get('temporary/getTemporaryInfo',{params :{ id : obj }})
                .then(response => {
                        if (response.data.code === 200) {
                            this.editTemporaryVisible=true;
                            this.temporaryDeatilList=response.data.result.temporaryDetails
                            this.editTemporary.name=  response.data.result.name
                            this.editTemporary.id=  response.data.result.id
                             this.$http.get('map/findMapById',{params :{ mapId : this.temporaryInfo.mapId}})
                            .then(response => {
                                    if (response.data.code === 200) {
                                        that.dataMap=response.data.result
                                        that.temporaryInfo.mapNo=that.dataMap.mapNo
                                        that.$nextTick(() => {  
                                             that.downloadOFile(that.dataMap.orginUrl,that.dataMap,"editmycanvas");
                                        }).catch(failResponse => {})
                                        
                                    }else{
                                        return this.$message.error(response.data.message);
                                    }
                                }).catch(failResponse => {
                                
                            })
                        }else{
                            return this.$message.error(response.data.message);
                        }
                    }).catch(failResponse => {
                })
            }
            
            

        },
        //删除临时任务
        deletTemporary(obj){
             this.$http.get('temporary/deleteTemporary',{params :{ id : obj }})
            .then(response => {
                    if (response.data.code === 200) {
                        this.$message.success("删除成功!");
                        this.searchTemporarys();
                        return
                    }else{
                        return this.$message.error(response.data.message);
                    }
                }).catch(failResponse => {
                
            })
        },
        deleteTemporaryDeatil(obj){
              for (var i = 0; i < this.temporaryDeatilList.length; i++) {
                    if(obj.pointNo==this.temporaryDeatilList[i].pointNo){
                        this.temporaryDeatilList.splice(i, 1);
                        return;
                    }
            }
        },
        addCleanJobDetail(){
            this.pointInfo={};
            this.addTemporary.temporaryDetail.pointNo='';
            this.addTemporary.temporaryDetail.time=300;
            this.addTemporary.temporaryDetail.type='';
        },
        editCleanJobDetail(){
            this.pointInfo={};
            this.editTemporary.temporaryDetail.pointNo='';
            this.editTemporary.temporaryDetail.time=300;
            this.editTemporary.temporaryDetail.type='';
        },
        editTemporaryDetail(){
            var temporaryDetail={pointNo:"",pointName:"",type:"",time:"",pointInfoId:""}
            if(this.pointInfo.pointNo ===''){
                return this.$message.error("请选择点位!");
            }
            if(this.editTemporary.temporaryDetail.type==''){
                return this.$message.error("请选择点位工作类型!");
            }
            if(this.editTemporary.temporaryDetail.time*1 < 1  || this.editTemporary.temporaryDetail.time*1 > 300 ){
                return  this.$message.error("请输入1~300数字!");
            }
            temporaryDetail.pointName=this.pointInfo.roomInfo
            temporaryDetail.pointNo=this.pointInfo.pointNo
            temporaryDetail.type=this.editTemporary.temporaryDetail.type
            temporaryDetail.time=this.editTemporary.temporaryDetail.time
            temporaryDetail.pointInfoId=this.pointInfo.id
            if(this.temporaryDeatilList.length>0){
                for(var i= 0; i < this.temporaryDeatilList.length; i++){
                    if(this.temporaryDeatilList[i].pointNo==temporaryDetail.pointNo){
                        return this.$message.error("该点位已经存在,请重新选择!");
                    }
                }
            }
            this.temporaryDeatilList.push(temporaryDetail)
            this.pointInfo={};
            this.editTemporary.temporaryDetail.pointNo='';
            this.editTemporary.temporaryDetail.time=300;
            this.editTemporary.temporaryDetail.type='';
        },
        addTemporaryDetail(){
            var temporaryDetail={pointNo:"",pointName:"",type:"",time:"",pointInfoId:""}
            if(this.pointInfo.pointNo===''){
                return this.$message.error("请选择点位!");
            }
            if(this.addTemporary.temporaryDetail.type==''){
                return this.$message.error("请选择点位工作类型!");
            }
            if(this.addTemporary.temporaryDetail.time*1 < 1  || this.addTemporary.temporaryDetail.time*1 > 300 ){
                return  this.$message.error("请输入1~300数字!");
            }
            temporaryDetail.pointName=this.pointInfo.roomInfo
            temporaryDetail.pointNo=this.pointInfo.pointNo
            temporaryDetail.type=this.addTemporary.temporaryDetail.type
            temporaryDetail.time=this.addTemporary.temporaryDetail.time
            temporaryDetail.pointInfoId=this.pointInfo.id
            temporaryDetail.roomInfo=this.pointInfo.roomInfo
            if(this.temporaryDeatilList.length>0){
                for(var i= 0; i < this.temporaryDeatilList.length; i++){
                    if(this.temporaryDeatilList[i].pointNo==temporaryDetail.pointNo){
                        return this.$message.error("该点位已经存在,请重新选择!");
                    }
                }
            }
            this.temporaryDeatilList.push(temporaryDetail)
            this.pointInfo={};
            this.addTemporary.temporaryDetail.pointNo='';
            this.addTemporary.temporaryDetail.time=300;
            this.addTemporary.temporaryDetail.type='';
        },
        changeSelectId(val){
            if(this.pointinfoList.length>0){
                if(this.institutionType==2){
                    for(var i= 0; i < this.pointinfoList.length; i++){
                        if( this.pointinfoList[i].pointNo== val){
                            if( this.pointinfoList[i].buildingNo==''|| this.pointinfoList[i].buildingNo==undefined||   this.pointinfoList[i].floorNo==''|| this.pointinfoList[i].floorNo==undefined||
                                this.pointinfoList[i].roomNo==''||this.pointinfoList[i].roomNo==undefined||this.pointinfoList[i].roomInfo==''||this.pointinfoList[i].roomInfo==undefined){
                                this.addTemporary.temporaryDetail.pointNo='';
                                return this.$message.error("请前往医院临时地图列表补充该点位信息!");
                            }else{
                                this.pointInfo=this.pointinfoList[i]
                            }
                        }

                    }
                }else if(this.institutionType==1){
                    for(var i= 0; i < this.pointinfoList.length; i++){
                         if( this.pointinfoList[i].pointNo== val){
                            this.pointInfo=this.pointinfoList[i]
                         }
                    }
                }
                    
            }
        },
        editChangeSelectId(val){
            if(this.pointinfoList.length>0){
               if(this.institutionType==2){
                    for(var i= 0; i < this.pointinfoList.length; i++){
                        if( this.pointinfoList[i].pointNo== val){
                            if(this.pointinfoList[i].buildingNo==''|| this.pointinfoList[i].buildingNo==undefined||   this.pointinfoList[i].floorNo==''|| this.pointinfoList[i].floorNo==undefined||
                                this.pointinfoList[i].roomNo==''||this.pointinfoList[i].roomNo==undefined||this.pointinfoList[i].roomInfo==''||this.pointinfoList[i].roomInfo==undefined){
                                this.addTemporary.temporaryDetail.pointNo='';
                                return this.$message.error("请前往医院临时地图列表补充该点位信息!");
                            }else{
                                this.pointInfo=this.pointinfoList[i]
                            }
                        }

                    }
                }else if(this.institutionType==1){
                    for(var i= 0; i < this.pointinfoList.length; i++){
                        if( this.pointinfoList[i].pointNo== val){
                            this.pointInfo=this.pointinfoList[i]
                        }
                    }
                }
            }
        },
        //关闭数据框
        addTemporaryClose(){
            this.clearCanvas('mycanvas');
            this.pointInfo={};
            this.addTemporary.temporaryDetail.pointNo='';
            this.addTemporary.temporaryDetail.time=300;
            this.addTemporary.temporaryDetail.type='';
            this.pointinfoList=[];
            this.dataMap='';
            this.temporaryDeatilList=[];
            this.addTemporary.name='';
            this.gcanvas=null
        },
        //保存数据
        addTemporaryData(){
            if(this.addTemporary.name==''){
                return this.$message.error("请输入任务名称!");
            }
            if(this.temporaryDeatilList.length==0){
                return this.$message.error("请编辑任务点信息!");
            }
            var pointNos=[];
            for(var i=0;i<this.temporaryDeatilList.length;i++){
                pointNos.push(this.temporaryDeatilList[i].pointName)
                if(this.temporaryDeatilList[i].time==""){
                    return this.$message.error("请补充点位编号为"+this.temporaryDeatilList[i].pointNo+"的任务消杀时长!");
                }
            }
            let temporary={robotNo:this.temporaryInfo.robotNo,mapNo: this.temporaryInfo.mapNo,name:this.addTemporary.name,temporaryDetails:this.temporaryDeatilList,pointNos:pointNos.join(",")}; 
            this.$http.post('/temporary/addTemporary',JSON.stringify(temporary)) .then(response => {
                if (response.data.code === 200) {
                   this.$message.success("保存成功!");
                   this.searchTemporarys();
                   this.addTemporaryVisible=false;
                   return
                }else{
                     return this.$message.error(response.data.message);
                }
                }).catch(failResponse => {
            })
        },
        //清理图片缓存
        clearCanvas(mycanvas){
            var c=document.getElementById(mycanvas);
            if(c==undefined){
                return;
            }
            var cxt=c.getContext("2d");
            cxt.clearRect(0,0,c.width,c.height);
        },
        //打开添加弹框
        addTemporarys(){
            let that=this
            if(this.institutionType==2){
                this.$http.get('map/findMapById',{params :{ mapId : this.temporaryInfo.mapId}})
                .then(response => {
                    if (response.data.code === 200) {
                            that.dataMap=response.data.result
                            that.temporaryInfo.mapNo=that.dataMap.mapNo
                            that.$http.get('map/findPointInfos',{params :{ robotNo : that.temporaryInfo.robotNo,mapNo : that.temporaryInfo.mapNo }})
                                .then(response => {
                                        if (response.data.code === 200) {
                                            that.pointinfoList=response.data.result
                                            console.log(that.pointinfoList)
                                            that.$nextTick(() => {  
                                                that.downloadOFile(that.dataMap.orginUrl,that.dataMap,"mycanvas");
                                            }).catch(failResponse => {})
                                        }
                                        
                                }).catch(failResponse => {
                            })
                            
                        }else{
                            return this.$message.error(response.data.message);
                        }
                    }).catch(failResponse => {
                    
                })
                this.addTemporaryVisible=true;
            }
            if(this.institutionType==1){
                this.$http.get('map/findMapById',{params :{ mapId : this.temporaryInfo.mapId}})
                .then(response => {
                    if (response.data.code === 200) {
                            that.dataMap=response.data.result
                            that.temporaryInfo.mapNo=that.dataMap.mapNo
                            that.$nextTick(() => {  
                            that.downloadOFile(that.dataMap.orginUrl,that.dataMap,"mycanvas");
                            }).catch(failResponse => {})
                        }else{
                            return this.$message.error(response.data.message);
                        }
                    }).catch(failResponse => {
                    
                })
                this.addTemporaryVisible=true;
            }
            
        },
        searchTemporarys(){
            var check = /[`~!@#$%^&*()\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/
            if(check.test(this.temporaryInfo.robotNo)||check.test(this.temporaryInfo.mapNo)){
                return this.$message.error("请输入非特殊字符!");
            }
           
            this.$http.get('temporary/selectTemporarys',{params :{ robotNo : this.temporaryInfo.robotNo  ,mapId : this.temporaryInfo.mapId,pageNum :this.temporaryInfo.num , name : this.temporaryInfo.name}})
            .then(response => {
                    if (response.data.code === 200) {
                        this.temporaryList=response.data.result.data
                        this.total=response.data.result.total
                        this.institutionType=response.data.result.institutionType
                        this.temporaryInfo.mapNo=response.data.result.mapNo
                    }else{
                        return this.$message.error(response.data.message);
                    }
                }).catch(failResponse => {
                
            })

        },
        handleCurrentChange(page){
            this.temporaryInfo.num=page;
            this.searchTemporarys();
        },
        clearParams(){
           this.temporaryInfo.name='';
        },
        connectMqtt(){
             if(this.mqttClient==null){
                //启动vuex初始化方法
                this.$store.dispatch('mqttServer')
                let that=this
                setTimeout(function() {
                       that.init();
                       that.searchTemporarys();
                    }, 1000)
             }else{
                this.init();
                this.searchTemporarys();
            }  
        },
        
        unsubscribe: function() {  
            this.mqttClient.unsubscribe(  
                    this.topic1, err => {  
                    console.log(err || '取消订阅成功');  
                }  
            );  
        },  
        returnMissionRobot(){
              this.$router.replace({path: '/temporaryMap?robotNo='+this.temporaryInfo.robotNo})
        },
       // 下载原点文件
       downloadOFile(url,dataMap,mycanva) {
        console.log('下载原点文件', url)
         this.$http.get(window.location.origin+url)
            .then(res => {
                const blob = new Blob([res.data])
                const reader = new FileReader()
                const that = this
                reader.readAsText(blob, 'utf-8')
                reader.onload = function() {
                console.log(reader.result)
                that.resolution = reader.result.substring(reader.result.indexOf('resolution:') + 'resolution:'.length, reader.result.indexOf('origin:'))
                var tempOrigin = reader.result.substring(reader.result.indexOf('[') + 1, reader.result.indexOf(']'))
                console.log(tempOrigin)
                var originArr = tempOrigin.split(',')
                that.origin_x = originArr[0]
                that.origin_y = originArr[1]
                console.log(dataMap.mapPngUrl)
                that.doDraw(dataMap.mapPngUrl,dataMap,mycanva)
            }  
            }).catch(res => {
                
            })
        },
         // imageUrl为后台提供图片地址
        doDraw(imageUrl,dataMap,mycanva) {
            // 获取canvas
            var canvas = document.getElementById(mycanva)
            // 由于弹窗，确保已获取到
            var a = setInterval(() => {
            // 重复获取
                canvas = document.getElementById(mycanva)
                if (!canvas) {
                    return false
                } else {
                clearInterval(a)
                // 可以理解为一个画笔，可画路径、矩形、文字、图像
                var context = canvas.getContext('2d')
                var scale = window.devicePixelRatio
                context.scale(scale, scale)
                var img = new Image()
                img.src = imageUrl
                const that = this
                // 加载图片
                img.onload = function() {
                    if (img.complete) {
                    // 根据图像重新设定了canvas的长宽
                    canvas.setAttribute('width', img.width)
                    canvas.setAttribute('height', img.height)
                    that.imageWidth = canvas.width
                    that.imageHeight = canvas.height
                    that.gcanvas = canvas
                    // 绘制图片
                    context.drawImage(img, 0, 0, img.width, img.height)
                    //起始点坐标计算公式
                    var x1 = (0 - that.origin_x) / that.resolution
                    var y1 = that.imageHeight - (0 - that.origin_y) / that.resolution
                    //画出原点坐标
                    that.doDrawLine(context, x1 - 10, y1, x1 + 10, y1, 'red', 2)
                    that.doDrawLine(context, x1, y1 - 10, x1, y1 + 10, 'red', 2)
                    //画轨迹
                    that.downloadRoadFile(dataMap.roadUrl,dataMap)
                    }
                  }
                }
            }, 10)
        },
        // 画线doDra
        doDrawLine(context, x1, y1, x2, y2, color, line) {
        context.beginPath()
        context.moveTo(x1, y1)
        context.lineTo(x2, y2)
        context.strokeStyle = color
        context.lineWidth = line
        context.stroke()
        },
        //根据轨迹文件画图
        downloadRoadFile(url,dataMap) {
            console.log('加载xml文件')
            this.$http.get(window.location.origin+url)
                .then(res => {
                        const blob = new Blob([res.data])
                        const reader = new FileReader()
                        const that = this
                        reader.readAsText(blob, 'utf-8')
                        reader.onload = function() {
                       //解析  
                        var map = that.$x2js.xml2js(reader.result)  
                        var xmlList = map.map.vertex
                        var lineXmlList = map.map.edge
                        var tempList = []
                        var lineist = []
                        for (var i = 0; i < xmlList.length; i++) {
                            var tempString = xmlList[i]
                            var Id =tempString._id
                            var X =tempString._x
                            var Y =tempString._y
                            var name =tempString._Name
                            tempList.push({ Id, X, Y })
                            var pointin={ "pointNo" : Id*1,roomInfo: name}
                             //添加参考点
                            if( that.pointinfoList.length < tempList.length){
                                that.pointinfoList.push(pointin)
                            }
                        }
                        if(lineXmlList.length===undefined){
                            var lineString = lineXmlList
                            var lid = lineString._id
                            var src_id = lineString._src_id
                            var dst_id = lineString._dst_id
                            lineist.push({ lid, src_id, dst_id })
                        }else{
                            for (var k = 0; k < lineXmlList.length; k++) {
                                var lineString = lineXmlList[k]
                                var lid = lineString._id
                                var src_id = lineString._src_id
                                var dst_id = lineString._dst_id
                                lineist.push({ lid, src_id, dst_id })
                            }
                        }
                        dataMap.dotList = tempList
                        dataMap.lineList = lineist
                        for (var j = 0; j < lineist.length; j++) {
                            var context = that.gcanvas.getContext('2d')
                            // var scale = window.devicePixelRatio
                            // context.scale(scale, scale)
                            var m = parseInt(lineist[j].src_id)
                            var n = parseInt(lineist[j].dst_id)
                            var x = parseFloat(dataMap.dotList[m].X)
                            var y = parseFloat(dataMap.dotList[m].Y)
                            x = (x - that.origin_x) / that.resolution
                            y = that.imageHeight - (y - that.origin_y) / that.resolution
                            var x2 = parseFloat(dataMap.dotList[n].X)
                            var y2 = parseFloat(dataMap.dotList[n].Y)
                            x2 = (x2 - that.origin_x) / that.resolution
                            y2 = that.imageHeight - (y2 - that.origin_y) / that.resolution
                            that.doDrawLine(context, x, y, x2, y2, 'blue', 2)
                        }
                        for (var l = 0; l < tempList.length; l++) {
                            var context1 = that.gcanvas.getContext('2d')
                            // var scale1 = window.devicePixelRatio
                            // context1.scale(scale1, scale1)
                            var x1 = parseFloat(dataMap.dotList[l].X)
                            var y1 = parseFloat(dataMap.dotList[l].Y)
                            x1 = (x1 - that.origin_x) / that.resolution
                            y1 = that.imageHeight - (y1 - that.origin_y) / that.resolution
                            that.doDrawSicle(context1, x1, y1, 'green', 3,l)
                        }
                    
                    }
                }).catch((error) => {
                    console.log(error)
                })
            },
        //机器人原点
        doDrawSiclePath(context, x, y, color, line) {
            context.beginPath()
            context.arc(x, y, line / 2, 2 * Math.PI, 0, true)
            context.lineWidth = line
            context.strokeStyle = color
            context.shadowOffsetX = 0
            context.shadowOffsetY = 0
            context.shadowColor = color
            context.shadowBlur = 0
            context.stroke()
        },
        // 画大圆点
        doDrawSicle(context, x, y, color, line,index) {
            context.beginPath()
            context.arc(x, y, line / 2, 2 * Math.PI, 0, true)
            context.lineWidth = line
            context.strokeStyle = color
            context.shadowOffsetX = 0
            context.shadowOffsetY = 0
            context.font="15px lighter arial";
            context.fillText(index,x,y);
            context.shadowColor = color
            context.shadowBlur = 0
            context.stroke()
        },

  }
  
}
</script>

<style lang="less" scoped>
.el-input {
    width: 150px;
}
.elll-input {
    width: 100px;
}
.ell-input {
    width: 200px;
}
.m-l-30 {
  margin-left: 30px !important;
}

.el-row {
    margin-bottom: 20px;
    display: flex;
    flex-wrap: wrap
}

.ell-row {
    margin-bottom: 40px;
    display: flex;
    flex-wrap: wrap
}
html,body,.XSDFXPage{
        width: 50%;
        height: 50%;
        overflow: hidden;
        margin: 0px auto;
        font-family: "微软雅黑";
}
.map {
        width: 100%;
        height: 400px;
}
.el-table{
    font-size: 10px;
    height:'20px';
    padding:'0px'
}
.ellll-input{
     width: 30px;
}
/deep/ .el-form-item__label {
    text-align: right;
    vertical-align: middle;
    float: left;
    font-size:20px;
    color: #606266;
    line-height: 40px;
    padding: 0 12px 0 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}

</style>


// WEBPACK FOOTER //
// src/components/robot/Temporary.vue